/**
 * Read a CSS custom property off the document root.
 *
 * The single source of truth for all colour — DOM and canvas/SVG — is the
 * `@theme` / `.dark` blocks in `entrypoints/application.css` (see ADR-005).
 * Canvas engines and inline SVG can't use Tailwind utilities, so they read the
 * resolved value here at render / engine-init time. Components that paint with
 * these values already re-run on theme toggle (their effects depend on `dark`),
 * so the recolour is automatic.
 *
 * Returns `fallback` when there is no document (SSR) or the variable is unset.
 */
export function cssVar(name: string, fallback = ''): string {
  if (typeof document === 'undefined') return fallback
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim()
  return value || fallback
}
